<template lang="pug">
	.section-container.section-home.section-loading
		hourglass
</template>

<script>
import HourglassComponent from '../components/HourglassComponent.vue'

export default {
	components: {
		Hourglass: HourglassComponent
	},
	data() {
		return {
			videoPopup: false,
		}
	},
	computed: {
		itLang() {
			return this.$t('locale.lang') === 'it'
		},
		esLang() {
			return this.$t('locale.lang') === 'es'
		},
		language() {
			return this.$t('locale.lang')
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.home") })
		document.getElementsByTagName("BODY")[0].classList.add('page-header')

		this.$root.$i18n.locale = 'it'
		this.$store.dispatch('general/setLocale', { locale: 'it' })
		this.$router.push('/it')
	},
	watch: {
		language() {
			if (this.videoPopup) {
				this.$refs.modalvideo.close()
				this.videoPopup = false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.section-loading
    min-height 60vh
    display flex
    width 100%
    align-items center
    justify-content center
</style>